import "./ModalNewGroup.css";
import {API} from "aws-amplify";
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import Select from '@material-ui/core/Select';
import React, {useEffect, useState} from "react";
import {makeStyles} from "@material-ui/core/styles";
import MenuItem from '@material-ui/core/MenuItem';
import InputLabel from '@material-ui/core/InputLabel';
import DialogTitle from '@material-ui/core/DialogTitle';
import FormControl from '@material-ui/core/FormControl';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import TextField from '@material-ui/core/TextField';
import {K_ALERT} from "../CommonUtilities/UtilityFunctions";
import {UVT_STARTING_CYCLES, plansForMajor} from "../../libs/Constants";

const useStyles = makeStyles((theme) => ({
    FormControl: {
        width: 550
    },
}));

export default function ModalEditGroup(props) {
    const classes = useStyles();
    const [groupData, setGroupData] = useState({
        group: '',
        major: '',
        startingDate: '',
        endingDate: '',
        startingCycle: '',
        plan: '',
        mode: '',
        cuatrimestre: ''
    });

    useEffect(() => {
        if (props.group && props.open) {
            setGroupData({
                groupId: props.group.groupId,
                group: props.group.group || '',
                major: props.group.major || '',
                startingDate: props.group.startingDate || '',
                endingDate: props.group.endingDate || '',
                startingCycle: props.group.startingCycle || '',
                plan: props.group.plan || '',
                mode: props.group.mode || '',
                cuatrimestre: props.group.cuatrimestre || ''
            });
        }
    }, [props.group, props.open]);

    const handleSubmit = async () => {
        props.callbackBackdrop(true);
        props.onClose();
        try {
            await updateGroupAPI(groupData);
            props.callbackSuccess();
            props.callbackBackdrop(false);
            props.callbackAlert({
                open: true,
                message: "El grupo ha sido actualizado satisfactoriamente",
                severity: "success"
            });
        } catch (e) {
            console.log(e);
            props.callbackBackdrop(false);
            props.callbackAlert({
                open: true,
                message: K_ALERT.MESSAGE.ERROR,
                severity: K_ALERT.SEVERITY.ERROR
            });
        }
    };

    const updateGroupAPI = (group) => {
        return API.put("misServiciosEscolares", `/groups/${group.groupId}`, {
            body: {
                startingDate: group.startingDate,
                endingDate: group.endingDate,
                plan: group.plan
            }
        });
    };

    return (
        <div className="ModalEditGroup">
            <Dialog open={props.open} onClose={props.onClose} aria-labelledby="form-dialog-title">
                <DialogTitle id="modal-edit-group">Editar Grupo</DialogTitle>
                <DialogContent>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="demo-simple-select-label">
                            Carrera (Requerido)*
                        </InputLabel>
                        <Select
                            id="major-select-major"
                            value={groupData.major}
                            onChange={(event) => setGroupData({...groupData, major: event.target.value})}
                            required
                            disabled
                            className={classes.FormControl}
                        >
                            <MenuItem value={"ENFERMERIA"}>Enfermería</MenuItem>
                            <MenuItem value={"ENFERMERIA_SEMESTRAL"}>Enfermería Semestral</MenuItem>
                            <MenuItem value={"PSICOPEDAGOGIA"}>Psicopedagogía</MenuItem>
                            <MenuItem value={"INDUSTRIAL"}>Industrial</MenuItem>
                            <MenuItem value={"ADMINISTRACION"}>Admin de Empresas</MenuItem>
                            <MenuItem value={"PETROLERA"}>Petrolera</MenuItem>
                            <MenuItem value={"DERECHO"}>Derecho</MenuItem>
                            <MenuItem value={"AMBIENTAL"}>Ambiental</MenuItem>
                            <MenuItem value={"LOGISTICA"}>Logística</MenuItem>
                            <MenuItem value={"MAESTRIAEDUCACION"}>Maestría en Educación</MenuItem>
                            <MenuItem value={"MAESTRIAPETROLERA"}>Maestría Petrolera</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="cuatrimestre">
                            Cuatrimestre (requerido)*
                        </InputLabel>
                        <Select
                            id="cuatrimestre-select"
                            value={groupData.cuatrimestre}
                            onChange={(event) => setGroupData({...groupData, cuatrimestre: event.target.value})}
                            required
                            disabled
                            className={classes.FormControl}
                        >
                            <MenuItem value={"1"}>1</MenuItem>
                            <MenuItem value={"2"}>2</MenuItem>
                            <MenuItem value={"3"}>3</MenuItem>
                            <MenuItem value={"4"}>4</MenuItem>
                            <MenuItem value={"5"}>5</MenuItem>
                            <MenuItem value={"6"}>6</MenuItem>
                            <MenuItem value={"7"}>7</MenuItem>
                            <MenuItem value={"8"}>8</MenuItem>
                            <MenuItem value={"9"}>9</MenuItem>
                            <MenuItem value={"10"}>10</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="group">
                            Grupo (requerido)*
                        </InputLabel>
                        <Select
                            id="group-select-group"
                            value={groupData.group}
                            onChange={(event) => setGroupData({...groupData, group: event.target.value})}
                            required
                            disabled
                            className={classes.FormControl}
                        >
                            <MenuItem value={"A"}>Grupo A</MenuItem>
                            <MenuItem value={"B"}>Grupo B</MenuItem>
                            <MenuItem value={"C"}>Grupo C</MenuItem>
                            <MenuItem value={"D"}>Grupo D</MenuItem>
                            <MenuItem value={"E"}>Grupo E</MenuItem>
                            <MenuItem value={"F"}>Grupo F</MenuItem>
                            <MenuItem value={"G"}>Grupo G</MenuItem>
                            <MenuItem value={"OPTATIVAS 1"}>OPTATIVAS 1</MenuItem>
                            <MenuItem value={"OPTATIVAS 2"}>OPTATIVAS 2</MenuItem>
                            <MenuItem value={"OPTATIVAS 3"}>OPTATIVAS 3</MenuItem>
                            <MenuItem value={"OPTATIVAS 4"}>OPTATIVAS 4</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="mode">
                            Modalidad (requerido)*
                        </InputLabel>
                        <Select
                            id="group-select-mode"
                            value={groupData.mode}
                            onChange={(event) => setGroupData({...groupData, mode: event.target.value})}
                            required
                            disabled
                            className={classes.FormControl}
                        >
                            <MenuItem value={"ESCOLARIZADO"}>Escolarizado</MenuItem>
                            <MenuItem value={"SABADOS"}>Sábados</MenuItem>
                            <MenuItem value={"DOMINGOS"}>Domingos</MenuItem>
                            <MenuItem value={"EN LINEA"}>En línea</MenuItem>
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="plan">
                            Plan (requerido)*
                        </InputLabel>
                        <Select
                            id="plan-select-plan"
                            value={groupData.plan}
                            onChange={(event) => setGroupData({...groupData, plan: event.target.value})}
                            required
                            className={classes.FormControl}
                        >
                            {plansForMajor(groupData.major).map(p => (
                                <MenuItem key={p} value={p}>{p}</MenuItem>
                            ))}
                            {groupData.plan === "2013" && <MenuItem value={"2013"}>2013</MenuItem>}
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="startingCycle">
                            Ciclo de Inicio (requerido)*
                        </InputLabel>
                        <Select
                            id="startingCycle"
                            value={groupData.startingCycle}
                            onChange={(event) => setGroupData({...groupData, startingCycle: event.target.value})}
                            required
                            disabled
                            className={classes.FormControl}
                        >
                            {UVT_STARTING_CYCLES.map(o => (
                                <MenuItem key={o} value={o}>{o}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id="startingDate"
                            label="Fecha de Inicio"
                            type="date"
                            value={groupData.startingDate}
                            onChange={(event) => setGroupData({...groupData, startingDate: event.target.value})}
                            className={classes.FormControl}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormControl>
                    <FormControl className={classes.formControl}>
                        <TextField
                            id="endingDate"
                            label="Fecha de Fin"
                            type="date"
                            value={groupData.endingDate}
                            onChange={(event) => setGroupData({...groupData, endingDate: event.target.value})}
                            className={classes.FormControl}
                            InputLabelProps={{
                                shrink: true,
                            }}
                        />
                    </FormControl>
                </DialogContent>
                <DialogActions>
                    <Button
                        onClick={props.onClose}
                        color="secondary"
                    >
                        Cancelar
                    </Button>
                    <Button
                        onClick={handleSubmit}
                        color="primary"
                    >
                        Actualizar Grupo
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    );
}
